export default "__VITE_ASSET__CqUTE8Uo__"